import { parseISO } from 'date-fns'
import { AcompanhamentoPreNatalQuery, AtendimentoProfissional, Medicao } from 'graphql/types.generated'
import { isEmpty, orderBy } from 'lodash'
import { isUndefinedOrNull } from 'util/checks'
import { OrigemDum } from 'view/atendimentos/detail/components/modals/medicoes/model-medicoes'
import {
  AtendimentoProfUltimaGestacao,
  HistoricoPreNatalModel,
} from 'view/atendimentos/detail/components/modals/types/model-historicoPreNatal'
import {
  MEDICOES_PRE_NATAL,
  PreNatalFormModel,
  TipoPreNatal,
} from 'view/atendimentos/detail/soap/pre-natal/model-preNatal'

import { MedicoesPreNatal } from '../../../../components/modals/types/model-historicoPreNatal'
import { isInicioOuContinuacaoPreNatal } from '../../../pre-natal/util-preNatal'
import { convertMedicoesAtendimentoAtual, convertMedicoesUltimaGestacao } from '../converter-acompanhamentoPreNatal'

export function getDumAtual(valoresComMedicaoAtual: AtendimentoProfissional[]): Date {
  for (let i = valoresComMedicaoAtual?.length - 1; i >= 0; i--) {
    const medicoes = valoresComMedicaoAtual[i]?.medicoes
    if (!isEmpty(medicoes) && medicoes[0].dum) {
      return parseISO(medicoes[0].dum)
    }
  }
}

function defineDumComStatus(valoresComMedicaoAtual: AtendimentoProfissional[], dumAtendimentoAtual?: string) {
  const dumPersistida = getDumAtual(valoresComMedicaoAtual)
  const dumFinal = dumAtendimentoAtual ? parseISO(dumAtendimentoAtual) : dumPersistida

  let origemDum: OrigemDum = OrigemDum.SEM_DUM
  if (dumAtendimentoAtual && dumPersistida) {
    origemDum = OrigemDum.AMBOS
  } else if (dumAtendimentoAtual) {
    origemDum = OrigemDum.ATENDIMENTO_ATUAL
  } else if (dumPersistida) {
    origemDum = OrigemDum.ATENDIMENTO_ANTERIOR
  }

  return { dum: dumFinal, origemDum }
}

export type MedicaoAtendProfPreNatal = Pick<
  Medicao,
  | 'id'
  | 'dataMedicao'
  | 'valorBatimentoCardiacoFetal'
  | 'dum'
  | 'valorAlturaUterina'
  | 'valorPressaoArterial'
  | 'valorPeso'
  | 'medicaoAnterior'
>

function hasMedicoesPreNatalAtendimentoAtual(preNatalAtendimentoAtual: PreNatalFormModel): boolean {
  if (isUndefinedOrNull(preNatalAtendimentoAtual)) return false
  return MEDICOES_PRE_NATAL.some((item) => preNatalAtendimentoAtual[item])
}

function mustShowMedicoesAtendimentoAtual(
  tipoPreNatal: TipoPreNatal,
  pesoAtendimentoAtual: number,
  preNatalAtendimentoAtual: PreNatalFormModel
): boolean {
  return (
    isInicioOuContinuacaoPreNatal(tipoPreNatal) &&
    (!isUndefinedOrNull(pesoAtendimentoAtual) || hasMedicoesPreNatalAtendimentoAtual(preNatalAtendimentoAtual))
  )
}

export interface ConvertDadosPreNatalProps {
  data: AcompanhamentoPreNatalQuery
  preNatalAtendimentoAtual?: PreNatalFormModel
  pesoAtendimentoAtual?: number
  dumAtendimentoAtual?: string
  dataAtendimento?: Instant
  tipoPreNatal?: TipoPreNatal
}

export function convertDadosPreNatal({
  data,
  dataAtendimento,
  dumAtendimentoAtual,
  preNatalAtendimentoAtual,
  pesoAtendimentoAtual,
  tipoPreNatal,
}: ConvertDadosPreNatalProps): HistoricoPreNatalModel {
  let medicoes: MedicoesPreNatal[] = []

  const atendimentosProfissionaisUltimaGestacao = data?.atendimentosProfUltimaGestacao

  const { dum, origemDum } = defineDumComStatus(
    atendimentosProfissionaisUltimaGestacao as AtendimentoProfissional[],
    dumAtendimentoAtual
  )

  atendimentosProfissionaisUltimaGestacao?.forEach((atendProf, index) => {
    const medicao = !isEmpty(atendProf.medicoes) ? atendProf.medicoes[0] : null
    const dataMedicao = medicao?.dataMedicao ?? atendProf.iniciadoEm
    medicoes.push(convertMedicoesUltimaGestacao(index, medicao, atendProf.atendimentoProfissionalPreNatal, dataMedicao))
  })

  mustShowMedicoesAtendimentoAtual(tipoPreNatal, pesoAtendimentoAtual, preNatalAtendimentoAtual) &&
    medicoes.push(
      convertMedicoesAtendimentoAtual(dataAtendimento, preNatalAtendimentoAtual, pesoAtendimentoAtual, medicoes?.length)
    )

  medicoes = orderBy(medicoes, 'numeroConsulta', 'desc')
  return {
    medicoesPreNatal: medicoes,
    dumMaisRecente: dum,
    origemDum,
  } as HistoricoPreNatalModel
}

export function getAltoRisco(atendimentos?: AtendimentoProfUltimaGestacao[]) {
  return atendimentos?.some((atendProf) => atendProf.atendimentoProfissionalPreNatal?.preNatal?.altoRisco)
}
